import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export type AnalyticsPeriod = "7d" | "30d" | "90d" | "all";

interface PeriodSelectorProps {
  value: AnalyticsPeriod;
  onChange: (value: AnalyticsPeriod) => void;
}

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as AnalyticsPeriod)}>
      <TabsList className="grid grid-cols-4 w-full sm:w-auto sm:inline-flex">
        <TabsTrigger value="7d" className="text-xs sm:text-sm">7 Days</TabsTrigger>
        <TabsTrigger value="30d" className="text-xs sm:text-sm">30 Days</TabsTrigger>
        <TabsTrigger value="90d" className="text-xs sm:text-sm">90 Days</TabsTrigger>
        <TabsTrigger value="all" className="text-xs sm:text-sm">All Time</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
